import { ChartSsoProvider } from "./Context/ChartSsoContext";
import { SsoLoginProvider } from "./Context/SsoLoginContext";
import { SyncDataModalProvider } from "./Context/SyncDataModalContext";
import CreateRoutes from "./routes";
function App() {
  return (
    <SyncDataModalProvider>
    
        <SsoLoginProvider>
        <ChartSsoProvider>
          <CreateRoutes />
          </ChartSsoProvider>
        </SsoLoginProvider>
     
    </SyncDataModalProvider>
  );
}

export default App;
